import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { faX } from '@fortawesome/pro-solid-svg-icons';
import { OrderableIngredient, Tag } from 'ngx-web-api';
@Component({
  selector: 'fts-ingredient-tags',
  templateUrl: './ingredient-tags.component.html',
  styleUrls: ['./ingredient-tags.component.scss'],
})
export class IngredientTagComponent implements OnInit {
  @Input()
  ingredient: OrderableIngredient;
  @Input()
  isInIngredientCard = false;
  @Input()
  isSelectedIngredientCard: boolean;

  @Output()
  tagClicked: EventEmitter<string> = new EventEmitter<string>();

  faX = faX;
  showableIngredients: Tag[] = [];
  nonShowableIngredients: Tag[] = [];

  ngOnInit(): void {
    this.ingredient?.tags.forEach(tag => {
      if (tag.name?.length <= 6 || tag.displayName?.length <= 6 || tag.abbreviation?.length <= 6) {
        if (!!tag.abbreviation && ((this.showableIngredients.length < 1 && this.isInIngredientCard) || !this.isInIngredientCard)) {
          this.showableIngredients.push(tag);
        } else {
          if (this.showableIngredients.length < (this.isInIngredientCard ? 1 : 2)) {
            this.showableIngredients.push(tag);
          } else {
            this.nonShowableIngredients.push(tag);
          }
        }
      } else {
        if (this.ingredient.tags.length === 1) {
          this.showableIngredients.push(tag);
        } else {
          this.nonShowableIngredients.push(tag);
        }
      }
    });
  }
}
